"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryFresh = exports.query = void 0;
var tslib_1 = require("tslib");
var queryProcessing_1 = require("./queryProcessing");
var effects_1 = require("redux-saga/effects");
/**
 * Runs the provided query and returns its result.
 *
 * @param q - query to run
 * @param refresh - indicates whether the query should ignore cached results and re-load data from backend
 */
function query(q, refresh) {
    var _a, promise, envelope, waitForResult;
    if (refresh === void 0) { refresh = false; }
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = queryProcessing_1.queryEnvelopeWithPromise(q, refresh), promise = _a.promise, envelope = _a.envelope;
                waitForResult = function () {
                    return promise;
                };
                /*
                 * dispatch the enveloped query. the envelope is setup so that upon query finish a promise will be resolved
                 */
                return [4 /*yield*/, effects_1.put(envelope)];
            case 1:
                /*
                 * dispatch the enveloped query. the envelope is setup so that upon query finish a promise will be resolved
                 */
                _b.sent();
                return [4 /*yield*/, effects_1.call(waitForResult)];
            case 2: return [2 /*return*/, _b.sent()];
        }
    });
}
exports.query = query;
/**
 * Runs the provided query, forcing refresh of any results that may be cached in the state, and returns its result.
 *
 * @param q - query to run
 */
function queryFresh(q) {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(query, q, true)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
exports.queryFresh = queryFresh;
//# sourceMappingURL=queryCall.js.map